import React from 'react';

function FormErrors({ formErrors }) {

    return (
      (formErrors.length > 0 ?
        <div className='alert alert-dismissible alert-danger'>
            <ul>
                {Object.keys(formErrors).map((i) => {
                    if (formErrors[i].length > 0) {
                        return (
                            <li key={i}>{formErrors[i]}</li>
                        )
                    } else {
                        return '';
                    }
                })}
            </ul>
        </div>
        : "")
    )
}

export default FormErrors;